import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { AuthService } from '../../services/auth.service';
import { PatientService } from 'src/app/services/patient.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Subscription } from 'rxjs';
import { ToastComponent } from 'src/app/shared/Toast/toast.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  practiceName: string;
  patientName: string;
  isMobileViewVisible
  userDetails:any;
  patientInvoiceList: any[] = [];
  private subscription!: Subscription;

  @ViewChild(ToastComponent) toast: ToastComponent | undefined;
  
  constructor(
    public authService: AuthService,
    private patientService: PatientService,
    protected encryptDecryptService: EncryptDecryptService,
    protected notificationService: NotificationService) {
    this.checkScreenSize()
  }
  ngOnInit() {

    this.subscription = this.notificationService.invoiceList$.subscribe(invoices => {
      this.patientInvoiceList = invoices;
    });

    this.authService.userDetails$.subscribe((userDetails) => {
      
      this.practiceName = userDetails.practiceName;
      this.patientName = userDetails.patientName;
    });




    const encryptedData = sessionStorage.getItem('u.');
    if (encryptedData !== null) {
      const decryptedData =
        this.encryptDecryptService.decryptUsingAES256(encryptedData);
      this.userDetails = JSON.parse(decryptedData);
    }
  }
  // HostListener to detect window resize
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }
  // Function to check screen size and toggle views
  checkScreenSize() {
    const screenWidth = window.innerWidth;
    // Assuming threshold is 768px for mobile view
    if (screenWidth <= 768) {
      this.isMobileViewVisible = true;
    } else {
      this.isMobileViewVisible = false;
    }
  }
  // logout function
  logOut() {
    this.authService._logOut();
  }
  closeMenu() {
    let navbarToggle = document.querySelector('.navbar-toggler');
    let navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse.classList.contains('show')) {
      navbarToggle.classList.add('collapsed');
      navbarCollapse.classList.remove('show');
    }
  }

  onGenerateStatement() {
    this.patientService.onGenerateStatement(this.userDetails.user_id).then((message: string) => {
    // console.log(message); // "File downloaded successfully"
  })
  .catch((errorMessage: string) => {
    this.toast?.showToast('Unable to retrieve the statement or statement not found.', 'error');
  });

  }
}
